import { useLocalStorage } from "../hooks/useLocalStorage";
import translations from "../assets/translations.json";
import type { AllowedLanguages } from "../hooks/useTranslation";

const typedTranslations: Record<string, { GERMAN: string; ENGLISH: string }> =
  translations;

function getLoadingLabel(language: string): string {
  const entry = typedTranslations["app_loading"];
  if (!entry) return "Loading …";
  return entry[language as keyof typeof entry] ?? entry.ENGLISH;
}

export default function LoadingScreen() {
  const [language] = useLocalStorage<AllowedLanguages>(
    "local-language",
    "ENGLISH",
  );

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-200 border-t-slate-400" />
        <p className="text-sm text-slate-500">{getLoadingLabel(language)}</p>
      </div>
    </div>
  );
}
